import { CurrencyEnum } from '@systemeio/ui'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'

export const getSortedChartCurrencies = (allCurrency: CurrencyEnum[], sums: AffiliateSumType) =>
  allCurrency.sort((a, b) => (sums[b] || 0) - (sums[a] || 0))
